import React, { useState } from 'react'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Accordion.module.scss'
import parse from 'html-react-parser'
import cx from 'classnames'

export interface AccordionProps {
  title: string
  description: {
    html: string
  }
}

const Accordion = ({ title, description }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)

  if (!title || !description) return null

  return (
    <div className={styles['accordion-container']}>
      <div className={styles['accordion-item']}>
        <div className={styles['accordion-header']} onClick={() => setIsOpen(!isOpen)}>
          <span className={styles['accordion-title']}>{title}</span>
          <FontAwesomeIcon
            icon={faAngleDown}
            className={cx(styles['accordion-icon'], {
              [styles['rotated']]: isOpen
            })}
          />
        </div>
        {isOpen && description.html && <div className={styles['accordion-description']}>{parse(description.html)}</div>}
        <hr className={styles['accordion-divider']} />
      </div>
    </div>
  )
}

export default Accordion
